<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="fabricStockCode"
      :checkboxConfig="{
        reserve: true,
        highlight: false,
        trigger: 'row',
        range: true,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width: 100px; height: 66px"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:stock="{ row }">
        <el-tag size="mini" :type="row.stockQuantity > 0 ? '' : 'danger'">
          {{ row.stockQuantity ? row.stockQuantity : "0" }}
          {{ row.fabricUnit ? row.fabricUnit : "" }}
        </el-tag>
      </template>
      <template v-slot:widAndWeight="{ row }">
        <span>{{ row.wid }} {{ row.widUnit }}</span>
        <br />
        <span>{{ row.fabricWeight }} {{ row.fabricWeightUnit }}</span>
      </template>
      <template v-slot:priceInfo="{ row }">
        <span>{{ row.unitPrice }} 元/ {{ row.fabricUnit }}</span>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <!-- <b-button
            class="mr-2"
            v-b-tooltip.hover
            title="查看"
            @click="formLoad('detail', row.fabricStockCode)"
            variant="outline-secondary"
            size="sm"
          >
            <b-icon-eye></b-icon-eye>
          </b-button> -->
          <b-button
            class="mr-2"
            v-b-tooltip.hover
            v-if="allow('M')"
            v-show="row.stockQuantity > 0"
            :title="$l('btn_tips_set') || '设置库位'"
            @click="setStorage(row.fabricStockCode)"
            variant="outline-secondary"
            size="sm"
          >
            <b-icon-columns-gap></b-icon-columns-gap>
          </b-button>
          <b-button
            v-b-tooltip.hover
            :title="$l('tips_print_tag') || '打印'"
            @click="printPdf(row.fabricStockCode)"
            variant="outline-secondary"
            size="sm"
            v-if="allow('P')"
          >
            <i class="fa fa-print"></i>
          </b-button>
          <b-button
            :class="{
              'mt-2': allow('M') && allow('P') && row.stockQuantity > 0,
              'ml-2': allow('P') && (!allow('M') || row.stockQuantity < 1),
            }"
            v-b-tooltip.hover
            :title="$l('btn_StockSearch') || '入库单查询'"
            @click="openDetail(row)"
            variant="outline-secondary"
            size="sm"
            v-if="allow('S')"
          >
            <i class="el-icon-search"></i>
          </b-button>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
    <storage ref="storage" :treeData="treeData" @refresh="refresh" />
    <!-- 业务人员调整弹框 -->
    <el-dialog
      :title="$l('INDEX.form_label_salesman_adjustment') || '业务人员调整'"
      :show-close="true"
      :visible.sync="turnoverVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formData"
        :model="formData"
        label-width="115px"
        style="margin-top: 30px;margin-bottom: 30px;"
      >
        <el-row :gutter="20">
          <el-form-item
            :label="$l('form_label_biz_user') || '业务员'"
            prop="fabricAgentCode"
          >
            <el-col :span="21">
              <dict-select
                v-model="formData.fabricAgentCode"
                url="/digitalCenter/common/dict/baseUser"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                style="width: 100%"
                filterable
                :multiple="false"
                clearable
                :options="{ label: 'label', value: 'code' }"
                :selectedLabel.sync="formData.fabricAgentName"
              ></dict-select>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">
          {{ $l("INDEX.btn_cancel") || "取消" }}
        </el-button>
        <el-button type="primary" @click="turnoverSave" size="small">{{
          $l("INDEX.tips_confirm") || "确认"
        }}</el-button>
      </div>
    </el-dialog>

    <el-drawer
      :title="this.$l('dialog_title_fabricIn') || '面料库存详情'"
      :visible.sync="detailVisible"
      size="50%"
      :before-close="handleDetailClose"
    >
      <div class="detail-wrapper">
        <Detail v-if="detailVisible" :rowData="currentRow" />
      </div>
    </el-drawer>
  </div>
</template>
<script>
import TableAutoHeight from "@/mixins/table-auto-height";

export default {
  mixins: [TableAutoHeight],
  components: {
    Storage: () => import("../storage"),
    Detail: () => import("../detail/index.vue"),
  },
  props: {
    tableData: {
      type: Array,
      value: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
    treeData: {
      type: Array,
      value: () => [],
    },
  },
  data() {
    return {
      detailVisible: false,
      detailKey: 0,
      currentRow: "",
      turnoverVisible: false,
      formData: {},
      tableToolbar: {
        slots: {
          buttons: "toolbar_form",
        },
        refresh: { query: () => this.$emit("submit") },
        zoom: true,
      },
      tableColumn: [
        {
          field: "col-opt",
          title: this.$l("INDEX.table_label_operation") || "操作",
          align: "center",
          width: 100,
          fixed: "right",
          slots: {
            default: "opt",
          },
        },
        {
          field: "seq",
          width: 60,
          align: "center",
          fixed: "left",
          type: "seq",
        },
        {
          width: 40,
          align: "center",
          type: this.single ? "radio" : "checkbox",
          fixed: "left",
        },
        {
          field: "imageCode",
          width: 120,
          title: "图片",
          align: "center",
          fixed: "left",
          slots: { default: "displayImage" },
        },
        {
          field: "fabricNo",
          minWidth: 180,
          fixed: "left",
          title: this.$l("table_label_fabric_no") || "面料编号",
        },
        {
          field: "fabricName",
          minWidth: 200,
          title: this.$l("table_label_fabric_name") || "面料名称",
        },
        {
          field: "fabricColorNo",
          minWidth: 200,
          title: this.$l("table_label_fabric_color_no") || "颜色编号",
        },
        {
          field: "fabricColorTitle",
          minWidth: 300,
          title: this.$l("table_label_fabric_color_title") || "颜色名称",
        },
        {
          field: "stockQuantity",
          width: 80,
          title: this.$l("table_label_quantity") || "库存",
          slots: { default: "stock" },
        },
        {
          field: "locationNo",
          width: 100,
          title: this.$l("form_label_location_no") || "库位",
        },
        {
          field: "widAndWeight",
          minWidth: 150,
          title: this.$l("form_label_wid_and_weight") || "门幅克重",
          slots: { default: "widAndWeight" },
        },
        {
          field: "priceInfo",
          minWidth: 150,
          title: this.$l("form_label_unitPrice") || "单价",
          slots: { default: "priceInfo" },
        },
        {
          field: "fabricAgentName",
          minWidth: 150,
          title: this.$l("form_label_biz_user") || "业务员",
        },
        {
          field: "supName",
          minWidth: 250,
          title: this.$l("form_label_supplier") || "供应商",
        },
        {
          field: "factoryNumber",
          minWidth: 180,
          title: this.$l("table_label_factory_number") || "工厂面料编号",
        },
        {
          field: "fabricContent",
          minWidth: 200,
          title: this.$l("table_label_fabric_composition") || "面料成分",
        },
        {
          field: "isCustomerExclusiveColorText",
          minWidth: 200,
          title: this.$l("table_label_isCustomerExclusiveColor") || "面料成分",
        },
        {
          field: "modifyInfo",
          width: 170,
          title: "Modify",
          slots: { default: "modifyInfo" },
        },
      ],
      formOption: {
        title: "",
        dialogFormVisible: false,
        dialogSaveBtnVisible: true,
      },
      selectList: [],
    };
  },
  methods: {
    openDetail(row) {
      this.currentRow = row;
      this.detailVisible = true;
    },
    // 处理详情弹框关闭
    handleDetailClose(done) {
      // 关闭弹框
      this.detailVisible = false;
      // 清空当前行数据
      this.currentRow = "";
      // 调用done函数完成关闭
      done();
    },
    // 加载表单
    formLoad(ref, val = "") {
      val = ref === "add" ? "1" : val;
      let params = {
        pageType: ref,
        fabricStockCode: val,
      };
      this.$router.push({
        name: "master-fabric-stock-detail",
        params: params,
      });
    },
    refresh() {
      this.$emit("submit");
    },
    setStorage(code) {
      this.$api
        .warehouseTreeApi()
        .then((res) => {
          this.treeData = res.body.data;
          this.$refs.storage.load(code);
        })
        .catch(() => {});
    },
    printTag() {
      // 缓存的选中数据，非当前页数据
      let reserveRecords = this.$refs.table.getCheckboxReserveRecords();
      // 当前页选中的数据
      let selectRecords = this.$refs.table.getCheckboxRecords();
      let totCount = reserveRecords.length + selectRecords.length;
      if (totCount === 0) {
        this.$message.warning("请选择需要打印标签的面料信息");
        return false;
      }
      if (totCount > 20) {
        this.$message.warning("一次打印的数量不能超过20个");
        return false;
      }
      this.selectList = [];
      // 将缓存中的选中数据，加入已选中数据列表
      if (reserveRecords.length > 0) {
        reserveRecords.forEach((row) => {
          this.selectList.push(row.fabricStockCode);
        });
      }
      // 将当前页选中数据，加入已选中数据列表
      if (selectRecords.length > 0) {
        selectRecords.forEach((row) => {
          this.selectList.push(row.fabricStockCode);
        });
      }
      this.print();
    },
    printPdf(fabricStockCode) {
      this.selectList = [fabricStockCode];
      this.print();
    },
    print() {
      if (this.selectList.length < 1) {
        this.$message({
          showClose: true,
          message: "请选择需要打印的标签",
          type: "warning",
        });
        return;
      }
      let data = { codeList: this.selectList };
      let fileName = "面料标签";
      this.$api.globalExportData(
        "/digitalCenter/fabric/stock/print",
        data,
        fileName
      );
      this.$refs.table.clearCheckboxRow();
      this.$refs.table.clearCheckboxReserve();
    },

    //业务人员调整选中数据
    getTurnoverSelectData() {
      const data = this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords());
      if (data.length < 1) {
        this.$message({
          showClose: true,
          message: this.$l("INDEX.tips_select_data") || "请选择数据!!",
          type: "warning",
        });
        return;
      }
      this.fabricStockCodeList = [];
      // 将缓存中的选中数据，加入已选中数据列表
      if (data.length > 0) {
        data.forEach((row) => {
          this.fabricStockCodeList.push(row.fabricStockCode);
        });
      }
      return this.fabricStockCodeList;
    },
    //业务人员调整
    turnoverSave() {
      if (
        typeof this.formData.fabricAgentCode == "undefined" ||
        this.formData.fabricAgentCode == ""
      ) {
        this.$message({
          showClose: true,
          message:
            this.$l("INDEX.form_label_please_select_a_business_person") ||
            "请选择业务人员!!",
          type: "warning",
        });
        return;
      }
      this.$confirm(
        this.$l("form_label_update_fabric_business_personnel") +
          this.formData.fabricAgentName +
          "】" ||
          "是否要将所选面料业务人员，更新为【" +
            this.formData.fabricAgentName +
            "】",
        {
          confirmButtonText: this.$l("INDEX.tips_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.tips_cancel") || "取消",
          type: "warning",
        }
      ).then(() => {
        this.$api
          .fabricStockTurnoverApi({
            fabricStockCodeList: this.fabricStockCodeList,
            fabricAgentCode: this.formData.fabricAgentCode,
          })
          .then(() => {
            this.turnoverVisible = false;
            this.$refs.table.clearCheckboxRow();
            this.$refs.table.clearCheckboxReserve();
            this.$message.success(
              this.$l("INDEX.tips_operate_ok") || "操作成功!"
            );
            this.$emit("submit");
          })
          .catch(() => {});
      });
    },
    async turnover() {
      const selectCode = await this.getTurnoverSelectData();
      if (!selectCode) {
        return;
      }
      this.formData = {};
      this.turnoverVisible = true;
    },
    cancel() {
      this.turnoverVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.detail-wrapper {
  border-radius: 4px;
  padding: 16px;
  margin: 16px;
  background-color: #fff;
}
</style>
